<template>
  <div class="calculator-form-item" @click.self="triggerFocus">
    <div
      class="calculator-input"
      :class="{ 'is-loading': isLoadingToggle }"
    >
      <label class="calculator-input__label" @click.self="triggerFocus">
        {{ label }}
      </label>
      <input
        v-imask="input.maskSettings"
        placeholder="0"
        :value="input.amountString"
        class="calculator-input__input"
        :class="{ 'is-updating': isPriceUpdateInProgress }"
        pattern="^[0-9]+([\.,][0-9]+)?$"
        inputmode="decimal"
        @accept="onAccept"
        :data-testid="dataTestid"
        ref="input"
      />
      <div class="calculator-input__loader"></div>
    </div>
    <CalculatorInputOptions
      :is-crypto="input.isCrypto()"
      :selected-option="input.currency.code"
      :items="currencies"
      @change="handleOptionChange"
      @is-open="$emit('option-is-open')"
      data-testid="currencydropdown"
    />
  </div>
</template>

<script>
import { IMaskDirective } from 'vue-imask';
import { mapState } from 'vuex';

import CalculatorInputOptions from '@kano/components/Calculator/CalculatorInputOptions.vue';


export default {
  name: 'CalculatorInput',

  components: {
    CalculatorInputOptions,
  },

  directives: {
    imask: IMaskDirective,
  },

  props: {
    input: { type: Object, required: true },
    currencies: { type: Array, required: true },
    isLoading: { type: Boolean, required: true },
    dataTestid: { type: String, required: false, default: null },
    label: { type: String, required: true },
  },

  data () {
    return {
      isLoadingToggle: this.isLoading,
    };
  },

  watch: {
    isLoading () {
      this.isLoadingToggle = this.isLoading;
    },
  },

  computed: {
    ...mapState('calculator', ['isPriceUpdateInProgress']),
  },

  methods: {
    triggerFocus () {
      this.$refs.input.focus();
    },
    handleOptionChange (selectedOption) {
      this.$emit('option-change', selectedOption);
    },
    onAccept (e) {
      const value = e.detail.value;

      if (this.input.amountString !== value && Number.parseFloat(this.input.amountString) !== Number.parseFloat(value)) {
        this.$emit('input-change', value);
      }
    },
  },
};
</script>
